import Enums from '@/common/enums/Enums';

export const AddOrRemoveBasePlanActionTypes = new Enums({
  ADD: 'add',
  REMOVE: 'remove',
  NO_ACTION: '',
});
